var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLLoader",class:_vm.classList},[_c('LoadingIcon',{staticClass:"LLLoader__icon"}),(_vm.slots.label)?_c('div',{staticClass:"LLLoader__label"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }